import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { JoinCtaButton } from '../components/JoinCtaButton'
import { PlacesPanelMap } from '../components/panel/PlacesPanelMap'
import { placesFull, placesMini } from '../data/placesIndex'
import { FULL_PASS_PUBLIC_ENABLED, publicCopyKey } from '../lib/productFlags'
import { useT } from '../i18n/t'
import { slugifyPl } from '../lib/slug'
import { fadeUp } from '../lib/motion'

export function LandingMapSection() {
  const { t } = useT()
  const navigate = useNavigate()
  const mapPlaces = FULL_PASS_PUBLIC_ENABLED ? placesFull : placesMini
  const mapTitleKey = publicCopyKey('landing.gallery.mapTitle', 'landing.gallery.mapTitleMiniOnly')
  const mapBodyKey = publicCopyKey('landing.gallery.mapBody', 'landing.gallery.mapBodyMiniOnly')

  return (
    <section className="container-x py-14 md:py-20">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={{ visible: { transition: { staggerChildren: 0.06 } } }}
        className="content"
        aria-label={t(mapTitleKey)}
      >
        <motion.p
          variants={fadeUp}
          className="text-xs font-extrabold uppercase tracking-[0.16em] text-ink/45"
        >
          {t('landing.gallery.mapEyebrow')}
        </motion.p>
        <motion.h2
          variants={fadeUp}
          className="mt-3 text-[22px] font-bold leading-[1.15] text-ink md:text-[28px]"
        >
          {t(mapTitleKey)}
        </motion.h2>
        <motion.p
          variants={fadeUp}
          className="mt-2 max-w-[52ch] text-[15px] font-medium leading-relaxed text-ink/60 md:text-base"
        >
          {t(mapBodyKey)}
        </motion.p>

        <motion.div variants={fadeUp} className="mt-6">
          <PlacesPanelMap
            places={mapPlaces}
            displayMode="publicCatalog"
            publicFeaturedPlaceId={13}
            onRegister={() => navigate('/formularz')}
            onOpenPlace={(placeId) => {
              const place = mapPlaces.find((p) => p.id === placeId)
              if (!place || place.comingSoon) return
              navigate(`/miejsca/${slugifyPl(place.name)}`)
            }}
            heightClassName="h-[400px] sm:h-[480px] md:h-[580px]"
          />
        </motion.div>

        <motion.div variants={fadeUp} className="mt-8">
          <JoinCtaButton size="lg" fullWidth className="sm:w-auto">
            {t('landing.map.cta')}
          </JoinCtaButton>
        </motion.div>
      </motion.div>
    </section>
  )
}
